import styles from './inlineLoader.module.scss';
export const InlineLoader = (props: any) => {
	return (
		<div className={`${styles.inlineLoader} ${props.showLoader? styles.visible :''}`}>
			<div className="loader"></div>
		</div>
	);
};